// libraries
import React from 'react'
import clsx from 'clsx'

// components
import Image from '/react4xp/components/Image'
import AnimatedArrow from '/react4xp/components/AnimatedArrow'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

// prop types
interface ArticleCardProps {
    href?: string
    external?: boolean
    src?: string
    srcMedium?: string
    alt?: string
    width?: number
    sizes?: string
    date?: string
    title?: string
    desc?: string
    className?: string
}

export default function ArticleCard({
    href,
    external,
    src,
    srcMedium,
    alt,
    width,
    sizes,
    date,
    title,
    desc,
    className
}: ArticleCardProps) {
    return (
        <a
            href={href}
            target={external ? '_blank' : undefined}
            className={clsx(
                'article-card',
                className
            )}
        >

            <div className={clsx(
                'article-card__image',
                !src && 'article-card__image--no-image'
            )}>
                {src && (
                    <Image
                        src={src}
                        srcMedium={srcMedium}
                        alt={alt}
                        width={width}
                        sizes={sizes}
                        className='cover'
                    />
                )}
            </div>

            <div
                className={clsx(
                    'article-card__mask',
                    src ?? 'article-card__mask--no-image'
                )}
            >
                <div className={clsx('article-card__wrapper', src ?? 'article-card__wrapper--no-image')}>

                    {isNonWhitespaceString(date) && (
                        <p className='article-card__wrapper__date text-smaller'>
                            {date}
                        </p>
                    )}

                    {isNonWhitespaceString(title) && (
                        <h3 className='article-card__wrapper__title h5'>
                            {title}
                        </h3>
                    )}

                    {isNonWhitespaceString(desc) && (
                        <div
                            className='article-card__wrapper__desc text-small'
                            dangerouslySetInnerHTML={{ __html: desc }}
                            suppressHydrationWarning
                        />
                    )}

                    <AnimatedArrow className='article-card__wrapper__arrow' />
                    
                </div>
            </div>

        </a>
    )
}